import { css } from '@emotion/react';
import React, { memo } from 'react';

import { COLORS2, LAYOUT2 } from '../../../Styles';

const SCAN_MENU_PANEL_STYLE = css`
  label: SCAN_MENU_PANEL_STYLE;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS2.alwaysDark.background.dark};
  height: 100%;
  gap: ${LAYOUT2.spacing1}px;
`;

const SCAN_MENU_SCROLL_CHILDREN_WRAPPER_STYLE = css`
  label: SCAN_MENU_SCROLL_CHILDREN_WRAPPER_STYLE;
  flex: 1;
  overflow-y: auto;
`;

export const ScanNavigatorLayout = memo(({
  fixedChildren,
  children,
}: {
  fixedChildren?: React.ReactNode;
  children: React.ReactNode;
}) => {
  return (
    <div css={SCAN_MENU_PANEL_STYLE}>
      {fixedChildren}
      <div css={SCAN_MENU_SCROLL_CHILDREN_WRAPPER_STYLE}>
        {children}
      </div>
    </div>
  );
});
